const Text =['First,solve the problem.Then,write the code','Fix the cause,not the symptom','Make it work,make it right,make it fast']
    

export default Text;